import type { VideoPlayerConfig } from "agora-rtc-react";
import type { SxProps, Theme } from "@mui/material";

export const meetVideoPlayerConfig: VideoPlayerConfig = { fit: "contain" };

export const videoFrameContainerSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#202124",
};

export const videoCallFrameOuterSx: SxProps<Theme> = {
  display: "flex",
  width: "100%",
  height: "100%",
  backgroundColor: "#0d1117",
};

export const videoCallFrameSidebarSx = (isDesktop: boolean): SxProps<Theme> => ({
  width: isDesktop ? 112 : 72,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  px: isDesktop ? 2 : 1,
  py: 2,
  backgroundColor: "#0A6172",
  borderRight: "1px solid rgba(255,255,255,0.12)",
});

export const videoCallFrameContentSx = (isDesktop: boolean): SxProps<Theme> => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
  p: isDesktop ? 2.5 : 1.5,
  gap: isDesktop ? 1.5 : 1,
});

export const videoCallFrameNamesBarSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 2,
  px: 0.5,
};

export const videoCallFrameNameSx: SxProps<Theme> = {
  color: "#E2E8F0",
  fontWeight: 600,
  fontSize: { xs: 12, sm: 14 },
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  flex: 1,
};

export const videoCallFrameVideoAreaSx: SxProps<Theme> = {
  position: "relative",
  flex: 1,
  minHeight: 0,
  borderRadius: 2,
  border: "2px solid #0A6172",
  overflow: "hidden",
  backgroundColor: "#202124",
  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.06)",
};
